import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AvitoIcon from "../../assets/icons/AvitoIcon";
import InstagramIcon from "../../assets/icons/InstagramIcon";
import TelegramIcon from "../../assets/icons/TelegramIcon";
// import ViberIcon from "../../assets/icons/ViberIcon";
import WhatsAppIcon from "../../assets/icons/WhatsAppIcon";
import Title from "../../ui/Title/Title";
import styles from "./ModalAddIntegration.module.scss";
import { WidgetIcon } from "../../assets/icons/WidgetIcon";
import { setNewWidget } from "../../store/slices/widgetSlice";
import { MessageBotIcon } from "../../assets/icons/MessageBotIcon";
import { useNavigate } from "react-router-dom";
import ModalTgIntegrationForm from "../ModalTgIntegrationForm/ModalTgIntegrationForm";
import ModalWaIntegrationForm from "../ModalWaIntegrationForm/ModalWaIntegrationForm";
import { setNewAvito } from "../../store/slices/avitoSlice";
import { ModalAvitoIntegrationForm } from "../ModalAvitoIntegrationForm/ModalAvitoIntegrationForm";
import { ButtonVk } from "../ButtonVk/ButtonVk";
import { ModalVkIntegration } from "../ModalVkIntegration/ModalVkIntegration";
import { useModal } from "../../context/ModalContext";
import { setNewVk } from "../../store/slices/vkSlice";
import { ModalBitrixIntegrationForm } from "../ModalBitrixIntegrationForm/ModalBitrixIntegrationForm";
import { BitrixIcon } from "../../assets/icons/BitrixIcon";
import { Modal } from "../../ui/Modal/Modal";
import { DialogFormIcon } from "../../assets/icons/DialogFormIcon";
import { setNewDialogsFW } from "../../store/slices/dialogFormWidgetSlice";
import {
  getQrCodeWa,
  getWhatsappIntegrations,
} from "../../utils/api/actions/integrations/whatsapp";
import {
  setNewBitrix,
  setNewBot,
  setNewInst,
  setNewTg,
  setNewWa,
} from "../../store/slices/integrationSlice";
import ModalInstagramIntegrationForm from "../ModalInstagramIntegrationForm/ModalInstagramIntegrationForm";
import { setNewDataBitrixChatBot } from "../../store/slices/bitrixChatBotSlice";
import { setNewDataGoogleSheets } from "../../store/slices/googleSheetsSlice";
import { ModalBitrixChatBotIntegrationForm } from "../ModalBitrixChatBotIntegrationForm/ModalBitrixChatBotIntegrationForm";
import RentProgIcon from "../../assets/icons/RentProgIcon";
import { GoogleSheetIcon } from "../../assets/icons/GoogleSheetIcon";
import { setNewDataRentProg } from "../../store/slices/rentProgSlice";
import { ModalRentProgIntegrationForm } from "../ModalRentProgIntegrationForm/ModalRentProgIntegrationForm";
import { AmoCRMIcon } from "../../assets/icons/AmoCRMIcon";
import { setNewDataAmo } from "../../store/slices/amoSlice";
import { ModalAmoIntegrationForm } from "../ModalAmoIntegrationForm/ModalAmoIntegrationForm";
import { ModalGoogleSheetsIntegrationForm } from "../ModalGoogleSheetsIntegrationForm/ModalGoogleSheetsIntegrationForm";

export default function ModalAddIntegration({ visible, onClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { closeModal } = useModal();

  const newAvito = useSelector((state) => state?.avito?.newAvito);
  const { newTg, newWa, newInst, newBitrix } = useSelector(
    (state) => state?.integration
  );
  const { newDataBitrixChatBot } = useSelector((state) => state?.bitrixChatBot);
  const { newDataGoogleSheets } = useSelector((state) => state?.googleSheets);
  const { newDataRentProg } = useSelector((state) => state?.rentProg);
  const { newDataAmo } = useSelector((state) => state?.amo);
  const id =
    useSelector((state) => state.user?.data?.id) ||
    localStorage.getItem("@storage_User_Id");
  const assistants = useSelector((state) => state?.assistant?.dataAssistants);
  const user = useSelector((state) => state.user?.data);

  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleVkModal, setVisibleVkModal] = useState(false);

  const handleOpenModal = () => {
    setVisibleModal(true);
  };

  const handleCloseModal = () => {
    if (newWa) {
      let dataWa = {
        userId: localStorage.getItem("@storage_User_Id"),
        clientIdentifier: localStorage.getItem("userPhone"),
      };
      dispatch(getQrCodeWa(dataWa, undefined, closeModal));
    }
    setVisibleModal(false);
    setVisibleVkModal(false);
    dispatch(getWhatsappIntegrations(id));
    dispatch(setNewTg(null));
    dispatch(setNewWa(null));
    dispatch(setNewInst(null));
    dispatch(setNewVk(null));
    dispatch(setNewAvito(null));
    dispatch(setNewBitrix(null));
    dispatch(setNewDataBitrixChatBot(null));
    dispatch(setNewDataGoogleSheets(null));
    dispatch(setNewDataRentProg(null));
    dispatch(setNewDataAmo(null));
    // closeModal();
  };

  const handleClickVk = () => {
    setVisibleVkModal(true);
  };

  const dataMessenger = [
    {
      name: "Telegram Bot",
      icon: <MessageBotIcon size={40} fill={"white"} />,
      onClick: () => {
        dispatch(
          setNewBot({
            userName: "",
            name: "",
            description: "",
            about: "",
            token: "",
            helloMessage: "",
            userId: id,
            assistantId: assistants ? assistants[0]?.id : "",
          })
        );
        navigate("telegram-bot/new");
        onClose(); // добавляем закрытие модалки интеграций
      },
    },
    {
      name: "Telegram",
      icon: <TelegramIcon width="62" height="62" />,
      onClick: () => {
        handleOpenModal();
        dispatch(
          setNewTg({
            phone: "",
            userId: id,
          })
        );
      },
    },
    {
      name: "WhatsApp",
      icon: <WhatsAppIcon fill={"#43d854"} />,
      onClick: () => {
        handleOpenModal();
        dispatch(
          setNewWa({
            email: user?.email,
            userId: id,
          })
        );
      },
    },
    {
      name: "ВКонтакте",
      icon: <ButtonVk />,
      onClick: () => {
        handleClickVk();
      },
    },
    {
      name: "Avito",
      icon: <AvitoIcon />,
      onClick: () => {
        handleOpenModal();
        dispatch(
          setNewAvito({
            userId: user?.id,
            clientId: "",
            clientSecret: "",
          })
        );
      },
    },
    {
      name: "Bitrix24",
      icon: <BitrixIcon width={75} height={55} fill={"#3e8fcb"} />,
      onClick: () => {
        handleOpenModal();
        dispatch(
          setNewBitrix({
            userId: id,
            apiURL: "",
          })
        );
      },
    },
    {
      name: "Bitrix24 Чат бот",
      icon: <BitrixIcon width={75} height={55} fill={"#3e8fcb"} />,
      onClick: () => {
        handleOpenModal();
        dispatch(
          setNewDataBitrixChatBot({
            userId: id,
            apiURL: "",
          })
        );
      },
    },
    {
      name: "Google Sheets документ",
      icon: <GoogleSheetIcon size={60} />,
      onClick: () => {
        handleOpenModal();
        dispatch(
          setNewDataGoogleSheets({
            userId: id,
            apiURL: "",
          })
        );
      },
    },
    // {
    //     name: 'Viber',
    //     icon: <ViberIcon />,
    // },
    {
      name: "Instagram",
      icon: <InstagramIcon />,
      onClick: () => {
        handleOpenModal();
        dispatch(
          setNewInst({
            userId: id,
          })
        );
      },
    },
    {
      name: "Виджет",
      icon: <WidgetIcon fill={"#3E8FCB"} width={57} height={57} />,
      onClick: () => {
        closeModal();
        navigate("widget/new");
        dispatch(
          setNewWidget({
            userId: id,
            name: "",
            assistantId: assistants ? assistants[0]?.id : "",
            assistantName: assistants ? assistants[0]?.name : "",
            color: "#2ca1f8",
            header: "Чат с ассистентом",
            allowedDomains: "",
            backgroundColor: "#ffffff",
            textColor: "#ffffff",
          })
        );
      },
    },
    {
      name: "Форма диалога",
      icon: <DialogFormIcon fill={"#3E8FCB"} width={57} height={57} />,
      onClick: () => {
        closeModal();
        navigate("dialog-form/new");
        dispatch(
          setNewDialogsFW({
            userId: id,
            assistantId: assistants ? assistants[0]?.id : "",
            assistantName: assistants ? assistants[0]?.name : "",
            allowedDomains: "",
            widgetColor: "#ffffff",
            widgetTextColor: "#000000",
            widgetBorderColor: "#d4d4d4",
            widgetInputColor: "#000000",
            widgetButtonColor: "#2088f7",
            widgetButtonDisabledColor: "#9e9e9e",
          })
        );
      },
    },
    {
      name: "RentProg",
      icon: <RentProgIcon />,
      onClick: () => {
        console.log("hello rent prog", newDataRentProg, visibleModal);
        handleOpenModal();
        dispatch(
          setNewDataRentProg({
            userId: "",
            componyToken: "",
          })
        );
      },
    },
    {
      name: "AmoCRM",
      icon: <AmoCRMIcon />,
      onClick: () => {
        console.log("hello amo crm", newDataAmo, visibleModal);
        handleOpenModal();
        dispatch(
          setNewDataAmo({
            userId: "",
            secretKey: "",
            integrationId: "",
            token: "",
          })
        );
      },
    },
  ];

  // const handlerClose = () => {
  //   onClose();
  //   dispatch(setNewBot(null));
  //   dispatch(setNewWidget(null));
  //   dispatch(setNewTg(null));
  //   dispatch(setNewWa(null));
  //   dispatch(setNewAvito(null));
  //   dispatch(setNewVk(null));
  //   dispatch(setNewDialogsFW(null));
  //   dispatch(setNewBitrix(null));
  //   // setVisible(false);
  // };

  const renderItem = (arr) => {
    return arr.map((el, i) => {
      return (
        <div
          className={
            el.name === "Telegram Bot" ||
            el.name === "Виджет" ||
            el.name === "Telegram" ||
            el.name === "WhatsApp" ||
            el.name === "Instagram" ||
            el.name === "Avito" ||
            el.name === "ВКонтакте" ||
            el.name === "Bitrix24" ||
            el.name === "Bitrix24 Чат бот" ||
            el.name === "Google Sheets документ" ||
            el.name === "RentProg" ||
            el.name === "AmoCRM" ||
            el.name === "Форма диалога"
              ? styles.itemContainerActive
              : styles.itemContainer
          }
          key={i}
          onClick={el.onClick}
        >
          <div className={styles.iconContainer}>{el.icon}</div>
          <label
            className={
              el.name === "Telegram Bot" ||
              el.name === "Виджет" ||
              el.name === "Telegram" ||
              el.name === "WhatsApp" ||
              el.name === "Instagram" ||
              el.name === "Avito" ||
              el.name === "ВКонтакте" ||
              el.name === "Bitrix24" ||
              el.name === "Bitrix24 Чат бот" ||
              el.name === "Google Sheets документ" ||
              el.name === "RentProg" ||
              el.name === "AmoCRM" ||
              el.name === "Форма диалога"
                ? styles.name
                : styles.disable
            }
          >
            {el.name}
          </label>
        </div>
      );
    });
  };

  return (
    <Modal visible={visible} handleClose={onClose}>
      {newTg && visibleModal && (
        <ModalTgIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newWa && visibleModal && (
        <ModalWaIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newInst && visibleModal && (
        <ModalInstagramIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newAvito && visibleModal && (
        <ModalAvitoIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newBitrix && visibleModal && (
        <ModalBitrixIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newDataBitrixChatBot && visibleModal && (
        <ModalBitrixChatBotIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newDataGoogleSheets && visibleModal && (
        <ModalGoogleSheetsIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newDataRentProg && visibleModal && (
        <ModalRentProgIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}
      {visibleVkModal && (
        <ModalVkIntegration
          visible={visibleVkModal}
          handlerClose={handleCloseModal}
        />
      )}
      {newDataAmo && visibleModal && (
        <ModalAmoIntegrationForm
          visible={visibleModal}
          handlerClose={handleCloseModal}
        />
      )}

      <div className={styles.layout}>
        <div className={styles.header}>
          <Title title="Добавление интеграции" className={styles.title} />
        </div>
        <div className={styles.body}>{renderItem(dataMessenger)}</div>
      </div>
    </Modal>
  );
}
